import React, { useState } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { CircleLoading } from '../../Assest/icons';

const DeleteModal = ({ show, onHide, data, deleteBoard }) => {

  const [loading, setLoading] = useState(false);

  const handleDelete = (data) => {
    deleteBoard(data.uuid,data.type,data.boardid)
    onHide();
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      className='delete-modal'
      centered>

      <div className='delete-header'>Delete</div>
      <Modal.Body className='w-100 '>
        <div className="deleteModal">
          <p>  Do you really want to delete the board?</p>
        </div>
      </Modal.Body>
      <div className='footerbtn mt-2'>
        <button className='cancel' onClick={() => onHide()}>
          Cancel
        </button>
        <button className={loading ? "loading save" : " "}
          onClick={() => handleDelete(data)}>
          {/* Delete */}
          {loading ?
            <CircleLoading/>
            :
            "Delete"
          }

        </button>
      </div>

    </Modal>
  )
}

export default DeleteModal